<template>
  <CycleBase cycletype="Forecast"></CycleBase>
</template>

<script>
import CycleBase from './Base.vue';
export default {
  name: 'commentary_forecast_cycle',
  // props: ['props'],
  data: function () {
    return {
    }
  },
  components: {
    CycleBase
  },
  created() {
    this.refreshData();
  },
  activated() {
    this.refreshData();
  },
  methods: {
    refreshData() {
    },
  },
  watch: {
  }
}
</script>
